import React from 'react';

const Header = ({ coupleName, destination, description, imageUrl }) => {
  return (
    <div className="relative h-96 bg-gray-900">
      <img 
        src={imageUrl || 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200'}
        alt={destination}
        className="w-full h-full object-cover opacity-70"
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white px-4">
        <h1 className="text-4xl md:text-6xl font-bold mb-4 text-center">{coupleName}</h1>
        <h2 className="text-2xl md:text-3xl mb-4 text-center">{destination}</h2>
        <p className="text-lg md:text-xl max-w-2xl text-center">{description}</p>
      </div>
    </div>
  );
};

export default Header;
